export default {
      id: "list-item-1-usage",
      viewBox: "0 0 5 5",
      url: __webpack_public_path__ + "img/icons.svg#list-item-1",
      toString: function () {
        return this.url;
      }
    }